module.exports = __webpack_public_path__ + "img/info-tablet.66e9e28b.svg";